// extracted by mini-css-extract-plugin
module.exports = {"root":"UserResponseTime_root__2yRr1","iconMessage":"UserResponseTime_iconMessage__RmkJu","text":"UserResponseTime_text__1dcFW"};